export const getIsBookmarkedByUser = (ids, id) => {
  if (!Array.isArray(ids)) return undefined;
  const isBookmarked = ids.includes(id);
  return isBookmarked;
};
